module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap-validation/~/babel-runtime/core-js/object/define-property.js
// module id = 725
// module chunks = 0